// Greedy x-sorted vertical staggering for chart peak/reference-line
// labels (PLPanel + PLAnalysisPanel). No external libs.
//
// xs:     label x positions (display units, same order as the labels)
// domain: [lo, hi] of the visible x axis (falls back to the xs extent)
// slots:  number of vertical slots to cycle through (default 3)
// minFrac: two labels closer than minFrac * domain-span collide
//
// Returns an array of slot indices (0..slots-1), one per input position,
// in the ORIGINAL order. Labels that don't collide with their left
// neighbor sit in slot 0; colliding neighbors take the next slot in the
// cycle, so adjacent labels never share a slot.
export function assignLabelSlots(xs, domain, slots = 3, minFrac = 0.08) {
  const n = xs.length;
  const out = new Array(n).fill(0);
  if (n === 0) return out;
  let lo = domain && Number.isFinite(domain[0]) ? domain[0] : Infinity;
  let hi = domain && Number.isFinite(domain[1]) ? domain[1] : -Infinity;
  if (!(hi > lo)) {
    lo = Math.min(...xs);
    hi = Math.max(...xs);
  }
  const span = Math.max(hi - lo, 1e-12);
  const order = xs.map((x, i) => [x, i]).sort((a, b) => a[0] - b[0]);
  let prevX = -Infinity;
  let prevSlot = -1;
  for (const [x, i] of order) {
    const collides = (x - prevX) < span * minFrac;
    out[i] = collides ? (prevSlot + 1) % slots : 0;
    prevSlot = out[i];
    prevX = x;
  }
  return out;
}
